import { STUDY_STATUS } from '@/entities/study';

const BIODIRECT_STATUS = {
  NEW: 'New',
  DELIVERING: 'Delivering',
  DELIVERED: 'Delivered',
  RUNNING: 'Running',
  COMPLETED: 'Completed',
  RETURNING: 'Returning',
  RETURNED: 'Returned',
  PENDING: 'Pending',
};

const CAN_STOP_STATUSES = [STUDY_STATUS.STARTED, STUDY_STATUS.RESUMED, STUDY_STATUS.PAUSED];

export { BIODIRECT_STATUS, CAN_STOP_STATUSES };
